/* eslint-disable max-len */

import _ from 'lodash';
import KeywordObject from '../models/SpottingGroupKeywordObject';

import {
  SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_NAME,
  SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_GROUP_TERMS,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SET_SEARCH_TERM,
  SPOTTING_GROUP_DRILLDOWN_FETCH_TERM,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_NAME,
  SPOTTING_GROUP_DRILLDOWN_EDITING_RESET,
  SPOTTING_GROUP_DRILLDOWN_RELOAD_GROUP,

  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_NOT_LOADED,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOAD_ERROR,
  SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_DELETED,

  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_NOT_LOADED,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOAD_ERROR,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_DELETED,

  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_NOT_LOADED,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOAD_ERROR,
  SPOTTING_GROUP_DRILLDOWN_EDITING_SAVE,
  SPOTTING_GROUP_DRILLDOWN_EDITING_DESTROY,

  SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_NOT_LOADED,
  SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_LOADING,
  SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_LOADED,
  SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_ERROR,


  SPOTTING_GROUP_DRILLDOWN_START_ADDING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_SAVE_ADDING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_ERROR,
  SPOTTING_GROUP_DRILLDOWN_STOP_ADDING_GROUP,

  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_NOT_ADDING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_ADDING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP_ERROR,
  SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVED_GROUP,

  SPOTTING_GROUP_DRILLDOWN_ADD_TERMS,
  SPOTTING_GROUP_DRILLDOWN_DELETE_CHECKED_TERMS,
  SPOTTING_GROUP_DRILLDOWN_SET_EDITING_GROUP_TERMS,
  SPOTTING_GROUP_DRILLDOWN_SAVE_ADDING_GROUP_TERMS,

  SPOTTING_GROUP_DRILLDOWN_SET_ADDING_GROUP_KEY,
  SPOTTING_GROUP_DRILLDOWN_SET_ADDING_STATE,
  SPOTTING_GROUP_DRILLDOWN_SET_SAVING_GROUP_ERROR,
  SPOTTING_GROUP_DRILLDOWN_SAVED_ADDING_GROUP,

  SPOTTING_GROUP_DRILLDOWN_SET_NEW_GROUP_TERMS,
  SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_RESET,

  SPOTTING_GROUP_SET_EDITING_KEYWORD,
  SPOTTING_GROUP_DRILLDOWN_INIT_NEW,
} from './spottingGroupDrilldownConstants';

import { makeSetValueAction, makeAction, keyToValueAction, updateAction } from '../utils';

/**
 * this function takes one or more arrays of strings OR keyword objects
 * and ensures that the output is a list of keyword objects.
 *
 * a keyword object is a pair of
 *
 * @param input
 * @returns {*}
 */

// ------------ ACTIONS

const mutators = new Map();

const providers = {
  fetchTerm: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_FETCH_TERM, _.identity),
  setCurrentNameID: updateAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_NAME, (state, name) => ({
    name,
    currentTermEditedName: name === 'new' ? '' : name,
  })),
  initNewSpottingGroup: updateAction(mutators, SPOTTING_GROUP_DRILLDOWN_INIT_NEW, () => ({
    name: '',
    currentTermEditedName: '',
    terms: [],
    termsEditing: KeywordObject.toList([]),
    termState: SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADED,
    savingGroupError: false,
    addGroupState: SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_NOT_ADDING_GROUP,
  })),
  addKeywords: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_ADD_TERMS, (state, terms) => {
    if (!(terms && Array.isArray(terms))) {
      return { ...state };
    }
    const termsEditing = KeywordObject.toList(state.termsEditing, terms);
    return { ...state, termsEditing };
  }),
  reloadGroup: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_RELOAD_GROUP, a => a),
  setTermState: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE, 'termState'),
  setTermStateLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADED, 'termState', SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADED),
  setTermStateNotLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_NOT_LOADED, 'termState', SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_NOT_LOADED),
  setTermStateLoading: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOADING, 'termState', SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOADING),
  setTermStateLoadError: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_GROUP_STATE_LOAD_ERROR, 'termState', SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_LOAD_ERROR),

  setTerms: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_CURRENT_GROUP_TERMS, (state, terms) => ({
    ...state,
    terms,
    termsEditing: KeywordObject.toList(terms),
  })),

  // actions for editing

  updateEditingKeyword: makeAction(mutators, SPOTTING_GROUP_SET_EDITING_KEYWORD, (state, {
    keyword,
    id,
  }) => {
    let { termsEditing } = state;
    if (!termsEditing) {
      termsEditing = [];
    }
    termsEditing = termsEditing.map((record) => {
      if (record.id === id) {
        return {
          keyword, id,
        };
      }
      return record;
    });
    return { ...state, termsEditing: KeywordObject.toList(termsEditing) };
  }),
  setEditingTermName: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_NAME, 'currentTermEditedName'),
  setEditingSearchTerm: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_EDITING_SET_SEARCH_TERM, 'searchTerm'),
  destroyGroup: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_EDITING_DESTROY, 'isEditingGroup', false),
  // destroyGroup triggers saga
  saveEdits: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_EDITING_SAVE, _.identity),
  // saveEdits triggers saga
  setEditingTerms: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_GROUP_TERMS, (state, terms) => ({
    ...state,
    termsEditing: KeywordObject.toList(terms),
  })),

  deleteCheckedTerms: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_DELETE_CHECKED_TERMS, (state) => {
    const { termsEditing, termsCheckList } = state;
    const remainingTerms = termsEditing.reduce((memo, term) => {
      if (termsCheckList.includes(term.id)) {
        return memo;
      }
      return [...memo, term];
    }, []);

    return {
      ...state,
      termsEditing: KeywordObject.toList(remainingTerms),
      termsCheckList: [],
    };
  }),
  setTermCheckList: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_EDITING_SET_CURRENT_TERM_CHECKLIST, 'termsCheckList'),
  setEditingState: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE, 'editingState'),
  setEditingStateNotLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_NOT_LOADED, 'editingState', SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_NOT_LOADED),
  setEditingStateLoading: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOADING, 'editingState', SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_LOADING),
  setEditingStateLoaded: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOADED, 'editingState', SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_LOADED),
  setEditingStateLoadError: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_EDITING_STATE_LOAD_ERROR, 'editingState', SPOTTING_GROUP_DRILLDOWN_EDITING_STATE_ERROR),
  editingWordsReset: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_EDITING_RESET, state => Object.assign({}, state, {
    searchTerm: '',
    termsCheckList: [],
    isEditingGroup: true,
    savingGroupError: false,
  })),

  setSavingGroupError: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_SAVING_GROUP_ERROR, 'savingGroupError'),
  // actions for adding words en masse

  setAddingState: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_ADDING_STATE, 'addGroupState'),
  // triggers saga
  saveAddingTerms: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_SAVE_ADDING_GROUP_TERMS, _.identity),
  setAddingStateNotAdding: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_STOP_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_NOT_ADDING_GROUP),
  setAddingStateAdding: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_START_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_ADDING_GROUP),
  setAddingStateError: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_ERROR, 'addGroupState', SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP_ERROR),
  setAddingStateSaving: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SAVE_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVING_GROUP),
  setAddingStateSaved: makeSetValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SAVED_ADDING_GROUP, 'addGroupState', SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_SAVED_GROUP),
  setAddGroupTerms: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_NEW_GROUP_TERMS, 'addingGroupTerms'),
  addingGroupReset: makeAction(mutators, SPOTTING_GROUP_DRILLDOWN_ADDING_GROUP_RESET, state => Object.assign({}, state, {
    currentTermEditedName: state.name,
    addingGroupTerms: '',
    addingGroupIsReplace: true,
    tabKey: 'preview',
  })),
  setTabKey: keyToValueAction(mutators, SPOTTING_GROUP_DRILLDOWN_SET_ADDING_GROUP_KEY, 'tabKey'),
};

// -------------- RESOLVER

const initialValue = {
  tabKey: 'preview',
  termsCheckList: [],
  currentTermEditedName: '',
  isEditingGroup: true,
  name: null,
  terms: [],
  termsEditing: [],
  searchTerm: '',
  termState: SPOTTING_GROUP_DRILLDOWN_GROUP_STATE_NOT_LOADED,
  addGroupState: SPOTTING_GROUP_DRILLDOWN_ADDING_STATE_NOT_ADDING_GROUP,
  addingGroupTerms: '',
  addingGroupIsReplace: true,
  savingGroupError: false,
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export default resolver;

const actions = Array.from(mutators.keys());

export {
  actions,
  providers,
};
